import clsx from "clsx";
import type { ReactNode } from "react";

/** Badge wie in der klassischen Stundennachweis-Tabelle (Bootstrap-`badge`). */
export function TimesheetBadge({
  children,
  className,
  subtle,
  warning,
  compact,
  title,
}: {
  children: ReactNode;
  className?: string;
  subtle?: boolean;
  warning?: boolean;
  compact?: boolean;
  title?: string;
}) {
  return (
    <span
      title={title}
      className={clsx(
        "inline-flex shrink-0 items-center rounded-full font-semibold leading-none",
        compact ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-0.5 text-xs",
        warning && "bg-amber-500 text-amber-950",
        subtle && "border border-separator/50 bg-fill-tertiary text-label-secondary",
        className,
      )}
    >
      {children}
    </span>
  );
}
